import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useUserState } from '../auth/UserState';
import { useWorkspaceId } from '../auth/WorkspaceState';
import { Assignment, getAllActiveTimeEntries, TimeEntry } from './assignment';
import { getUserAssignments } from './assignmentService';

type ActiveTimerResult = {
  assignment: Assignment | null;
  timeEntry: TimeEntry | null;
};

const emptyTimer: ActiveTimerResult = { assignment: null, timeEntry: null };

export const useActiveTimerQuery = () => {
  const { user } = useUserState();
  const workspaceId = useWorkspaceId();
  const userId = user?.uid;

  return useQuery<ActiveTimerResult>({
    queryKey: ['activeTimer', userId, workspaceId],
    queryFn: async () => {
      if (!userId || !workspaceId) return emptyTimer;

      try {
        const assignments = await getUserAssignments(userId, workspaceId);
        const activeTimers = getAllActiveTimeEntries(assignments, userId);
        return activeTimers[0] || emptyTimer;
      } catch (error) {
        console.error('Error fetching active timers:', error);
        return emptyTimer;
      }
    },
    refetchInterval: 30000, // Refresh every 30 seconds
    enabled: !!userId && !!workspaceId,
  });
};

export const useRefreshActiveTimer = () => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: ['activeTimer'] });
  };
};
